import { useState } from 'react';

export default function About() {
  const [showCertificates, setShowCertificates] = useState(false);
  const [currentCertificate, setCurrentCertificate] = useState(0);

  const certificates = [
    {
      title: 'Экономист-менеджер',
      institution: 'Волгоградский государственный архитектурно-строительный университет',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/771bf98b61ed8c0ff57a9a8fe1dceabf.jpeg'
    },
    {
      title: 'Таргетолог',
      institution: 'Convert Monster',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/73a9f9515cf25b97c626020f4f5cb8ce.jpeg'
    },
    {
      title: 'Instagram-Marketolog',
      institution: 'Convert Monster',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/564872b9f27ac0edbf7a25ca42eb6a89.png'
    },
    {
      title: 'Педагогика и Психология',
      institution: 'Волгоградский государственный социально-педагогический университет',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/8d50a4d864a800b7d2e79e3f72b5c3f1.png'
    },
    {
      title: 'Сертификат курса',
      institution: 'Образовательное учреждение',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/8a58d895d03b5a37da1f293318147789.png'
    },
    {
      title: 'Маркетинговые автоворонки для бизнеса',
      institution: 'Convert Monster',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/d5cee80e8b50569fd9a7c93173645569.png'
    },
    {
      title: 'Новый сертификат',
      institution: 'Образовательное учреждение',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/a0a927a4b25daeee4f455dd61f51d863.jpeg'
    },
    {
      title: 'Сертификат специалиста',
      institution: 'Образовательное учреждение',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/704ea87e4ec70e8b3d65836a24769c4f.jpeg'
    },
    {
      title: 'Сертификат участника',
      institution: 'MBM.RU',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/c677e13c0aafbb7bcb1aa649622fa995.jpeg'
    },
    {
      title: 'Продающий Taplink',
      institution: 'Taplink Academy',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/e4954a02ad7b85b8fecda33979465681.jpeg'
    },
    {
      title: 'Контекстная реклама',
      institution: 'GeekBrains',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/fe86de5220bf463bbbe0541902393ca8.jpeg'
    },
    {
      title: 'Сертификат BotHelp',
      institution: 'BotHelp',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/901d39f4c7ba402fc128b1f5d6c413c9.png'
    },
    {
      title: 'Техно-Бог Онлайн-Школы',
      institution: 'Техно-Бог Онлайн-Школа',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/d6e65af8fb38d158caabe4fa3f2d4d80.png'
    },
    {
      title: 'Техно-Бог Онлайн-Школы (Профессионал)',
      institution: 'Техно-Бог Онлайн-Школа',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/4529a66dbfc2f6bd780dc254edbcbef1.png'
    },
    {
      title: 'Я Топ-Селлер Wildberries',
      institution: 'Меркатус',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/f06124e67c84a96fed498c0e331fb07a.png'
    },
    {
      title: 'Выход в ТОП на Ozon',
      institution: 'Меркатус',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/28e1420f46634772fc6963739f3a4ab1.png'
    },
    {
      title: 'Управление репутацией (SERM)',
      institution: 'Меркатус',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/0855821310265b01bfbb3eac74dbd03e.png'
    },
    {
      title: 'Стратегический маркетинг',
      institution: 'Меркатус',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/2611d623b8d7faa9ecc319920781d8ed.png'
    },
    {
      title: 'Я селлер - СберМегаМаркет',
      institution: 'Меркатус',
      image: 'https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/5575e73b7fd1950998c99fc975e1aba0.png'
    }
  ];

  const nextCertificate = () => {
    setCurrentCertificate((prev) => (prev + 1) % certificates.length);
  };

  const prevCertificate = () => {
    setCurrentCertificate((prev) => (prev - 1 + certificates.length) % certificates.length);
  };

  return (
    <section className="py-24 bg-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <div className="max-w-7xl mx-auto px-6">

        {/* DNA Section - Navy Background */}
        <div className="rounded-3xl p-12 md:p-16 mb-16 relative overflow-hidden" style={{ background: '#1A2B4C' }}>
          {/* Decorative rings */}
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full border border-white/10"></div>
          <div className="absolute -bottom-20 -left-20 w-96 h-96 rounded-full border border-white/10"></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full border border-white/5"></div>

          <div className="relative z-10">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full mb-6 border" style={{ borderColor: '#C5A880', background: 'rgba(197,168,128,0.1)' }}>
                <span className="text-sm font-semibold tracking-widest uppercase" style={{ color: '#C5A880' }}>О нас</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                Эволюция от Топ-эксперта<br />до Основателя
              </h2>
              <div className="w-16 h-0.5 mx-auto mb-6" style={{ background: '#C5A880' }}></div>
              <p className="text-lg max-w-4xl mx-auto leading-relaxed" style={{ color: 'rgba(255,255,255,0.75)' }}>
                Мы не верим в интуитивный маркетинг. Мы верим в точность данных, глубину психологии и скорость алгоритмов. Наша компания — это симбиоз академического образования, жесткой практики в ведущих агентствах и передовых технологий.
              </p>
            </div>
          </div>
        </div>

        {/* Founder Section */}
        <div className="rounded-3xl p-12 md:p-16 mb-16" style={{ background: '#F8F9FA' }}>
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Photo */}
            <div className="order-2 lg:order-1">
              <div className="relative">
                <div className="absolute -inset-2 rounded-3xl" style={{ background: 'linear-gradient(135deg, #1A2B4C, #C5A880)', opacity: 0.2 }}></div>
                <div className="relative bg-white rounded-3xl overflow-hidden shadow-2xl">
                  <img
                    src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/b5a83a46aaca1163ce20a0c491f11d56.jpeg"
                    alt="Ирина Шарова-Ялынпала - Основатель и Идеолог"
                    className="w-full h-auto object-cover object-top"
                  />
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="order-1 lg:order-2">
              <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full mb-6 text-white text-sm font-semibold tracking-wider uppercase" style={{ background: '#1A2B4C' }}>
                <i className="ri-user-star-line"></i>
                Основатель и Идеолог
              </div>
              <h3 className="text-4xl font-bold mb-3" style={{ fontFamily: "'Playfair Display', serif", color: '#1A2B4C' }}>
                Ирина Шарова-Ялынпала
              </h3>
              <div className="w-12 h-0.5 mb-4" style={{ background: '#C5A880' }}></div>
              <p className="text-base font-semibold mb-5" style={{ color: '#C5A880' }}>
                Основатель агентства · Директор по маркетингу · Эксперт по системному росту
              </p>
              <p className="text-base mb-8 leading-relaxed" style={{ color: '#4a5568' }}>
                Мой путь — это не случайный успех, а закономерный результат постоянного обучения и работы на передовой рынка.
              </p>

              {/* Quote */}
              <div className="rounded-2xl p-6 relative" style={{ background: '#1A2B4C' }}>
                <div className="absolute top-4 left-5 text-5xl leading-none font-serif" style={{ color: '#C5A880', opacity: 0.4 }}>"</div>
                <p className="text-base leading-relaxed text-white pt-4 pl-4">
                  Моя цель — превратить ваш маркетинг из «чёрной дыры» для бюджета в управляемый актив, который приносит прибыль 24/7.
                </p>
                <div className="mt-4 pt-4 border-t" style={{ borderColor: 'rgba(197,168,128,0.3)' }}>
                  <span className="text-sm font-semibold" style={{ color: '#C5A880' }}>— Ирина Шарова-Ялынпала</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Journey Timeline */}
        <div className="bg-white rounded-3xl p-12 md:p-16 shadow-xl mb-16" style={{ border: '1px solid #F0EDE8' }}>
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full mb-5 text-sm font-semibold tracking-wider uppercase" style={{ background: 'rgba(197,168,128,0.12)', color: '#C5A880' }}>
              <i className="ri-route-line"></i>
              Путь к результату
            </div>
            <h3 className="text-4xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#1A2B4C' }}>
              От лучшей студентки до Собственного Бизнеса
            </h3>
            <div className="w-16 h-0.5 mx-auto mb-4" style={{ background: '#C5A880' }}></div>
            <p className="text-base max-w-3xl mx-auto" style={{ color: '#6b7280' }}>
              Путь от академического образования через работу в топовом агентстве к созданию собственной компании
            </p>
          </div>

          <div className="space-y-8">
            {/* Step 1 */}
            <div className="relative pl-10 border-l-2" style={{ borderColor: '#C5A880' }}>
              <div className="absolute -left-3 top-0 w-6 h-6 rounded-full border-2 border-white" style={{ background: '#C5A880' }}></div>
              <div className="rounded-2xl p-6" style={{ background: '#F8F9FA', border: '1px solid #e8e2d9' }}>
                <h4 className="text-xl font-bold mb-3" style={{ fontFamily: "'Playfair Display', serif", color: '#1A2B4C' }}>
                  Фундаментальный старт
                </h4>
                <p className="text-sm leading-relaxed mb-4" style={{ color: '#4a5568' }}>
                  Я зашла в профессию, имея за плечами два высших образования: <strong style={{ color: '#1A2B4C' }}>Педагогика и Психология</strong> (понимание людей) + <strong style={{ color: '#1A2B4C' }}>Экономика и Управление</strong> (понимание денег). Освоила Digital-маркетинг с нуля в топовом центре Convert Monster, пройдя путь от копирайтера до стратега.
                </p>
                <div className="rounded-xl p-4 border-l-4" style={{ background: 'white', borderColor: '#C5A880' }}>
                  <p className="text-sm font-semibold" style={{ color: '#1A2B4C' }}>
                    ✓ Результат: Признана лучшей студенткой потока и получила личное приглашение на работу в штат агентства Convert Monster.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="relative pl-10 border-l-2" style={{ borderColor: '#C5A880' }}>
              <div className="absolute -left-3 top-0 w-6 h-6 rounded-full border-2 border-white" style={{ background: '#C5A880' }}></div>
              <div className="rounded-2xl p-6" style={{ background: '#F8F9FA', border: '1px solid #e8e2d9' }}>
                <h4 className="text-xl font-bold mb-3" style={{ fontFamily: "'Playfair Display', serif", color: '#1A2B4C' }}>
                  Результаты в полях
                </h4>
                <p className="text-sm leading-relaxed mb-4" style={{ color: '#4a5568' }}>
                  Работая в отделе трафика, я управляла бюджетами до <strong style={{ color: '#1A2B4C' }}>1 000 000 ₽/мес</strong> (недвижимость) и работала с десятками ниш: от строительства домов до отелей.
                </p>
                <div className="rounded-xl p-4 border-l-4" style={{ background: 'white', borderColor: '#C5A880' }}>
                  <p className="text-sm font-semibold" style={{ color: '#1A2B4C' }}>
                    ✓ Результат: За 2021 год отдел трафика при моём участии увеличил прибыль агентства на 150%. Я доказала на практике, что умею масштабировать чужой бизнес.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative pl-10" style={{ borderLeft: '2px solid #C5A880' }}>
              <div className="absolute -left-3 top-0 w-6 h-6 rounded-full border-2 border-white" style={{ background: '#1A2B4C' }}></div>
              <div className="rounded-2xl p-6" style={{ background: '#1A2B4C' }}>
                <h4 className="text-xl font-bold mb-3 text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Логичная вершина — Своя Компания
                </h4>
                <p className="text-sm leading-relaxed mb-4" style={{ color: 'rgba(255,255,255,0.8)' }}>
                  Накопленная экспертиза, умение выстраивать стратегии и брать ответственность за деньги клиента позволили мне занять позицию <strong style={{ color: '#C5A880' }}>Директора по маркетингу</strong>. Но я видела, что рынку нужно больше, чем стандартные решения.
                </p>
                <div className="rounded-xl p-4 border-l-4" style={{ background: 'rgba(255,255,255,0.08)', borderColor: '#C5A880' }}>
                  <p className="text-sm font-semibold" style={{ color: '#C5A880' }}>
                    ✓ Поэтому я основала собственную компанию. Здесь я реализую своё видение: объединяю системный маркетинг с технологиями Искусственного Интеллекта, чтобы давать клиентам прогнозируемый рост без «слива» бюджета.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* AI Philosophy Section */}
        <div className="rounded-3xl p-12 md:p-16 mb-16 relative overflow-hidden" style={{ background: '#1A2B4C' }}>
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-72 h-72 rounded-full" style={{ background: 'rgba(197,168,128,0.06)', transform: 'translate(30%, -30%)' }}></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 rounded-full" style={{ background: 'rgba(197,168,128,0.04)', transform: 'translate(-30%, 30%)' }}></div>

          <div className="relative z-10">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full mb-6 border" style={{ borderColor: '#C5A880', background: 'rgba(197,168,128,0.1)' }}>
                <i className="ri-robot-line" style={{ color: '#C5A880' }}></i>
                <span className="text-sm font-semibold tracking-widest uppercase" style={{ color: '#C5A880' }}>Философия ИИ</span>
              </div>
              <h3 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Почему в основе компании лежит ИИ?
              </h3>
              <div className="w-16 h-0.5 mx-auto mb-6" style={{ background: '#C5A880' }}></div>
              <p className="text-base max-w-3xl mx-auto leading-relaxed" style={{ color: 'rgba(255,255,255,0.75)' }}>
                В списке моих профессиональных навыков всегда был пункт: «Умение анализировать большой объём данных». Раньше на это уходили недели. Теперь, как основатель, я внедрила Искусственный Интеллект во все процессы агентства.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              {[
                { icon: 'ri-speed-line', title: 'Ускорить рутину', text: 'То, что человек делает 40 часов, наши алгоритмы делают за 40 минут.' },
                { icon: 'ri-shield-check-line', title: 'Исключить ошибки', text: 'Машина видит неочевидные связи в статистике, которые может упустить глаз даже опытного маркетолога.' },
                { icon: 'ri-money-dollar-circle-line', title: 'Снизить стоимость лида', text: 'Мы находим самые дешёвые и эффективные связки быстрее конкурентов.' },
                { icon: 'ri-line-chart-line', title: 'Прогнозируемый рост', text: 'Каждый шаг просчитан машиной и проверен экспертом для максимальной эффективности.' },
              ].map((item, i) => (
                <div key={i} className="rounded-2xl p-6 flex items-start gap-5 transition-all duration-300 hover:translate-y-[-2px]" style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(197,168,128,0.2)' }}>
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: 'rgba(197,168,128,0.15)', border: '1px solid rgba(197,168,128,0.3)' }}>
                    <i className={`${item.icon} text-xl`} style={{ color: '#C5A880' }}></i>
                  </div>
                  <div>
                    <h4 className="text-base font-bold text-white mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{item.title}</h4>
                    <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.7)' }}>{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Hard Skills Section */}
        <div className="bg-white rounded-3xl p-12 md:p-16 shadow-xl mb-16" style={{ border: '1px solid #F0EDE8' }}>
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full mb-5 text-sm font-semibold tracking-wider uppercase" style={{ background: 'rgba(197,168,128,0.12)', color: '#C5A880' }}>
              <i className="ri-tools-line"></i>
              Компетенции
            </div>
            <h3 className="text-4xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: '#1A2B4C' }}>
              Ключевые компетенции (Hard Skills)
            </h3>
            <div className="w-16 h-0.5 mx-auto mb-4" style={{ background: '#C5A880' }}></div>
            <p className="text-base max-w-3xl mx-auto" style={{ color: '#6b7280' }}>
              Я и моя команда закрываем весь спектр задач Digital-маркетинга
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {[
              { icon: 'ri-lightbulb-line', title: 'Стратегия и Управление', text: 'Конкурентный анализ, Медиапланирование, Unit-экономика, управление командой подрядчиков.' },
              { icon: 'ri-advertisement-line', title: 'Весь платный трафик', text: 'Профессиональная настройка Яндекс.Директ (Поиск, РСЯ), Google Ads и таргетированной рекламы (Instagram, Facebook, VK, MyTarget).' },
              { icon: 'ri-shopping-cart-line', title: 'Маркетплейсы', text: 'Вывод в ТОП и масштабирование продаж на Ozon и Wildberries.' },
              { icon: 'ri-bar-chart-box-line', title: 'Аналитика', text: 'Сквозная аналитика, Google Analytics, Яндекс.Метрика. Принятие решений только на основе цифр (Data Driven).' },
            ].map((item, i) => (
              <div key={i} className="rounded-2xl p-6 flex items-start gap-5 transition-all duration-300 hover:shadow-md" style={{ background: '#F8F9FA', border: '1px solid #e8e2d9' }}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: '#1A2B4C' }}>
                  <i className={`${item.icon} text-xl`} style={{ color: '#C5A880' }}></i>
                </div>
                <div>
                  <h4 className="text-base font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif", color: '#1A2B4C' }}>{item.title}</h4>
                  <p className="text-sm leading-relaxed" style={{ color: '#4a5568' }}>{item.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Certificates Button */}
          <div className="text-center">
            <button
              onClick={() => setShowCertificates(!showCertificates)}
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              style={{ background: '#1A2B4C', color: '#C5A880', border: '1px solid #C5A880' }}
            >
              <i className="ri-award-line text-xl"></i>
              {showCertificates ? 'Скрыть дипломы и сертификаты' : 'Посмотреть дипломы и сертификаты'}
            </button>
          </div>

          {/* Certificates Carousel */}
          {showCertificates && (
            <div className="mt-12">
              <div className="relative rounded-2xl p-8" style={{ background: '#F8F9FA', border: '1px solid #e8e2d9' }}>
                <div className="mb-6">
                  <div className="bg-white rounded-xl overflow-hidden shadow-lg">
                    <img
                      src={certificates[currentCertificate].image}
                      alt={certificates[currentCertificate].title}
                      className="w-full h-auto object-contain"
                    />
                  </div>
                </div>
                <div className="flex items-center justify-center gap-4">
                  <button
                    onClick={prevCertificate}
                    className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
                    style={{ border: '1px solid #e8e2d9' }}
                  >
                    <i className="ri-arrow-left-s-line text-2xl" style={{ color: '#1A2B4C' }}></i>
                  </button>
                  <div className="flex gap-2">
                    {certificates.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentCertificate(index)}
                        className="h-3 rounded-full transition-all duration-300 cursor-pointer"
                        style={{
                          width: index === currentCertificate ? '2rem' : '0.75rem',
                          background: index === currentCertificate ? '#C5A880' : '#d1c9be'
                        }}
                      ></button>
                    ))}
                  </div>
                  <button
                    onClick={nextCertificate}
                    className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
                    style={{ border: '1px solid #e8e2d9' }}
                  >
                    <i className="ri-arrow-right-s-line text-2xl" style={{ color: '#1A2B4C' }}></i>
                  </button>
                </div>
                <div className="text-center mt-4">
                  <p className="text-sm" style={{ color: '#9ca3af' }}>{currentCertificate + 1} / {certificates.length}</p>
                </div>
              </div>
            </div>
          )}
        </div>

      </div>
    </section>
  );
}
